import { useCallback, useEffect, useState } from 'react';
import { deviceActions, useDeviceStore } from '../../store';
import { Device } from '../../types';
import { detectOrientation } from '../../utils/detectOrientation';
import { updatePageType } from '../../utils/updatePageType';
import { useScreenSize } from '../useScreenSize';

const { SET_DEVICE } = deviceActions;

export const useUpdateDeviceStore = () => {
  const deviceOptions = useDeviceStore();

  const screenType = useScreenSize();

  const [device, setDevice] = useState<Device>(deviceOptions);

  const handleOrientation = useCallback(
    () =>
      setDevice((prevDevice) => ({
        ...prevDevice,
        ...detectOrientation()
      })),
    []
  );

  useEffect(() => {
    window.addEventListener('orientationchange', handleOrientation);
    return () =>
      window.removeEventListener('orientationchange', handleOrientation);
  }, []);

  useEffect(() => {
    setDevice((prevDevice) => ({
      ...prevDevice,
      ...updatePageType(screenType)
    }));
  }, [screenType]);

  useEffect(() => {
    SET_DEVICE(device);
  }, [device]);
};
